/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './course-statistics.stache';
import FeedService from 'scripts/services/base-feed-service';

const courseStatisticsUrl = window.globalSettings.feeds.smt.courseStatisticsUrl;
const playerComparisonPageUrl =
    window.globalSettings.pagePaths.playerComparison;
const playerStatisticsUrl = window.globalSettings.pagePaths.playerStatistics;

Component.extend({
    tag: 'course-statistics',
    template,
    viewModel: {
        define: {
            fetching: {
                type: 'boolean',
                value: true,
            },
            playerStatisticsUrl: {
                type: 'string',
                value: playerStatisticsUrl,
            },
            missedFairway: {
                type: 'object',
            },
            playerComparisonPageUrl: {
                get() {
                    const urlOptions = {
                        player1: '',
                        player2: '',
                    };
                    return can.sub(playerComparisonPageUrl, urlOptions);
                },
            },
            dataNotAvailable: {
                type: 'boolean',
                value: false,
            },
        },
    },
    events: {
        inserted() {
            new FeedService({
                feedUrl: courseStatisticsUrl,
                fromCache: false,
                autoUpdate: false,
            })
                .on('fetching', (ev, value) =>
                    this.viewModel.attr('fetching', value),
                )
                .on('data', (type, data) => {
                    this.viewModel.attr('summary', data.summary);
                    this.viewModel.attr('roundsInfo', data.roundsInfo);
                    this.viewModel.attr(
                        'missedFairway',
                        data.missedFairwayPenalty,
                    );
                })
                .on('error', () =>
                    this.viewModel.attr('dataNotAvailable', true),
                )
                .fetch();
        },
    },
});
